<template>
<div class="chapter">
<div class="inner_page">
<h1 class="ct" id="pz3-1">Contents </h1>
<p class="cct1" id="pz3-2"><i>Foreword by Shauna Niequist</i> </p>
<p class="cct" id="pz3-3"><a href="#/chapter03#toc03" id="con03"><b><i>Chapter One:</i> Losing Your Ship without Losing Your Soul</b> </a></p>
<p class="cct" id="pz3-5"><i>Chapter Two:</i> How Not to Survive a Shipwreck </p>
<p class="cct" id="pz3-6"><span href="#/chapter04#toc04" id="con04" title="Link target outside of Sample"><b><i>Chapter Three:</i> Hold On, Let Go</b> </span></p>
<p class="cct" id="pz3-7"><span href="#/chapter05#toc05" id="con05" title="Link target outside of Sample"><b><i>Chapter Four:</i> Eating, Breathing, Sleeping</b> </span></p>
<p class="cct" id="pz3-8"><i>Chapter Five:</i> God Loves Monsters </p>
<p class="cct" id="pz3-9"><i>Chapter Six:</i> Choose Your Own Adventure </p>
<p class="cct" id="pz3-10"><i>Chapter Seven:</i> Don’t Fight the Wind </p>
<p class="cct" id="pz3-11"><i>Chapter Eight:</i> Starting to See </p>
<p class="cct" id="pz3-12"><i>Chapter Nine:</i> The City beneath the Sea </p>
<p class="cct2" id="pz3-13"><i>Acknowledgments</i> </p>
<p class="cct3" id="pz3-14"><span href="#/chapter06#toc06" id="con06" title="Link target outside of Sample"><b><i>Notes</i></b></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?af058dce